module.exports = __webpack_public_path__ + "static/Frogsong3-098cd6810a83a1f1d5904dd373dc0c33.png";